// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fe3b1ece","453":"34105afb","732":"4ffaeff7","977":"5ce08473"}[chunkId] + ".chunk.js";
};